
import { defineComponent } from 'vue';


/**
 * Vue components define
 */
export default defineComponent({
	setup() {
		return {};
	},
})
